import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import {
  EmitNotificationData,
  NotificationData,
} from '../../models/visit.model';

@Injectable({
  providedIn: 'root',
})
export class ScheduleSocketService {
  private socket: Socket;

  public selectScheduleShip: BehaviorSubject<
    NotificationData
  > = new BehaviorSubject<NotificationData>({
    datetime: '',
    idBroker: '',
    socketId: '',
  });
  public deselectScheduleShip: BehaviorSubject<
    NotificationData
  > = new BehaviorSubject<NotificationData>(null);

  public socketId: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() {}

  public configSocketConnection(): void {
    this.socket = io(environment.SERVER, {
      forceNew: true,
      transports: ['websocket'],
    });
  }

  public connectToScheduleVisit(roomName: string): void {
    this.configSocketConnection();
    this.joinRoom(roomName);
    this.selected();
    this.deselected();
    this.shareSocketId();
  }

  public joinRoom(roomName: string): void {
    this.socket.emit('calendarVisit', { nameRoom: roomName });
  }

  public notification(emitNotificationData: EmitNotificationData): void {
    const {
      roomName,
      datetime,
      shipType,
      socketId,
      brokerId,
    } = emitNotificationData;
    this.socket.emit('calendarVisit-notification', {
      nameRoom: roomName,
      event: shipType,
      slot: {
        datetime,
        idBroker: brokerId,
        socketId,
      },
    });
  }

  public shareSocketId(): void {
    this.socket.on('connect', () => {
      this.socketId.next(this.socket.id);
    });
  }

  public selected(): void {
    this.socket.on('timeslot_selected', (data) => {
      this.selectScheduleShip.next(data);
    });
  }

  public deselected(): void {
    this.socket.on('timeslot_deselected', (data) => {
      this.deselectScheduleShip.next(data);
    });
  }

  public disconnect(): void {
    this.socket.disconnect();
  }
}
